import * as Yup from 'yup';

interface IErrors {
  amountRequired: string,
  amountMin: string,
  notNumber: string,
}

function validationSchema(errors: IErrors) {
  return Yup.object().shape({
    field: Yup.number()
      .typeError(errors.notNumber)
      .required(errors.amountRequired)
      // @ts-ignore
      .test('min', errors.amountMin, val => val > 0)
  });
}

export const validationAmountField = (val: any, errors: IErrors) => {
  const value = { field: val };

  const schema = validationSchema(errors);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
